import React from "react";
import "./CareersContent.css";
import BenefitsCards from "./BenefitsCards";
import CareersCta from "./CareersCta";

const CareersContent = ({
    className,
    title,
    subtitle,
    image1,
    image2,
    sectionHeading,
    sectionBody,
    benefitsHeading,
    benefits,
    tableHeading,
    colorMode
}) => {
    return (
        <>
        <div className={`column is-flex is-flex-direction-column ${className}`}>
            <h1 className={`mb-4 title is-align-center ${colorMode}`}>{title}</h1>
            <h2 className={`mb-5 subtitle is-align-center ${colorMode}`}>{subtitle}</h2>

            {/* Photo widget container for responsive square images */}
            <div className="is-flex is-justify-content-center ">
                <div className="is-flex is-justify-content-center is-align-items-center">
                    {/* Two images side by side on desktop/tablet, single image on mobile */}
                    <div className="is-flex is-flex-direction-row-tablet is-flex-direction-column-mobile is-justify-content-center is-align-items-center">
                        
                        {/* First image - always visible */}
                        <div className="main-image mr-4-tablet mb-4-mobile">
                            <img 
                                src={image1} 
                                alt="Kinder's Career Image"
                                style={{
                                    objectFit: 'cover',
                                    width: '100%',
                                    height: 'auto',
                                    aspectRatio: '1',
                                }}
                                className="square-image"
                                onError={(e) => {
                                    
                                    e.target.style.border = '2px solid #ccc';
                                    e.target.alt = 'Image not found';
                                }}
                            />
                        </div>
                        
                        {/* Second image - hidden on mobile */}
                        <div className="main-image mr-4-tablet mb-4-mobile hide-mobile">
                            <img 
                                src={image2} 
                                alt="Kinder's Career Image"
                                style={{
                                    objectFit: 'cover',
                                    width: '100%',
                                    height: 'auto',
                                    aspectRatio: '1',
                                }}
                                className="square-image"
                                onError={(e) => {
                                    
                                    e.target.style.border = '2px solid #ccc';
                                    e.target.alt = 'Image not found';
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <h3 className={`mt-5 pt-6 mb-1 mx-6 subtitle is-align-center ${colorMode}`}>{sectionHeading}</h3>
            <p className={`mx-6-desktop px-6-desktop about is-align-center ${colorMode}`}>{sectionBody}</p>
            <CareersCta colorMode={colorMode} />
                
            <h3 className={`content-space-100 subtitle is-align-center ${colorMode}`}>{benefitsHeading}</h3>
            <BenefitsCards benefits={benefits} />
            
            {/* <h3 className={`content-space-100 subtitle is-align-center ${colorMode}`}>{tableHeading}</h3> */}
            
            
        </div> 
        </>
    );
}

export default CareersContent;